import axios from 'axios';
import cookie from "react-cookies";
import moment from 'moment';
import {sessionSecret} from "../../env.json";
import { Encryptor } from "../../components/global/encryptor";

const { encrypt, decrypt } = Encryptor(sessionSecret);

export const getAuthState = form => {
    const userCookie = cookie.load('MetroMatrix_Care_Website');
    if(!userCookie) return false;
    const params = JSON.parse(decrypt(userCookie))

    if(moment(params.expiresOn).subtract(5,'minutes').diff(moment()) < 0) return 'Expired'
    
    if(form === 'bool') return !!params.token;
    if(!!params[form]) return params[form]
    else return params
}

export const setAuthState = (authParams, isRemember) => {
    if(!authParams){ 
        return cookie.remove('MetroMatrix_Care_Website', { path: '/' });
    }
    const encryptedData = encrypt(JSON.stringify(authParams));
    let cookieOptions = !isRemember ? { path : '/', secure : true } : { path : '/', maxAge : 7776000, secure : true };
    cookie.save('MetroMatrix_Care_Website', encryptedData, cookieOptions)
}

const checkExcludedPath = () => {
    const excludedPaths = ['login'];
    let check = true
    for (const path of excludedPaths){
        if(window.location.pathname.includes(path)){
             check = false;
        }
    }
    return check;
}

export const setRefreshedCookie = async (config) => {
    const safeToUpdate = checkExcludedPath();
    
    if( !safeToUpdate || !config ) return;
    try {
        const { data : updatedCookie } = await axios.get('/api/doctor/auth/getUpdatedToken', config);
        if(!updatedCookie) throw 'Authentication failed';
        const maxAge = ( moment( updatedCookie.expiresOn ).diff( moment(), 'days') + 1 ) * 86400;

        const encryptedData = encrypt(JSON.stringify(updatedCookie));

        let cookieOptions = maxAge <= 86400 ? { path : '/', secure : true } : { path : '/', maxAge : maxAge, secure : true };
        cookie.save('MetroMatrix_Care_Website', encryptedData, cookieOptions);
    } catch (err) {
        throw new Error(err.message || 'Authentication failed');
    }
}